import { render, staticRenderFns } from "./BlogsCategories.vue?vue&type=template&id=050aa0b4&scoped=true"
import script from "./BlogsCategories.vue?vue&type=script&lang=js"
export * from "./BlogsCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050aa0b4",
  null
  
)

export default component.exports